export default __webpack_public_path__ + "static/social-share-21ef3ed92db796bd493b9bcf74a430a9.jpg";